import { createFileRoute } from '@tanstack/react-router'
import { FEATURE } from '@trellis/shared'

import { FeatureGate, RoleGate } from '@/components/guards'
import { FeatureDisabledPage } from '@/pages/features/FeatureDisabledPage'
import { AccessSettingsPage } from '@/pages/settings/organization/AccessSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/access/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <FeatureGate feature={FEATURE.IP_ALLOWLISTING} fallback={<FeatureDisabledPage />}>
      <RoleGate requires="OWNER">
        <AccessSettingsPage />
      </RoleGate>
    </FeatureGate>
  )
}
